<template>
  <div class="feed-game-details">
    <div class="form">
      <div class="bordered-panel">
        <div class="form__row">

          <div class="form__input-box ">
            <v-select label="Select language" :items="locales" :item-value="i => i.value" :item-text="i => i.name"
                    v-model="selectedLocaleValue"
                    @change="localeSelectOnChange" variant="outlined">
            </v-select>
          </div>

        </div>
        <div class="form__row">
          <div class="multiple-inputs-wrap">
            <div class="form__input-box form__input-box&#45;&#45;small">
              <v-text-field variant="outlined" label="Alias"
                     v-model="meta.alias"
                     v-input-trim
                     maxlength="50"
              />
            </div>
            <div class="form__input-box form__input-box&#45;&#45;small">
              <v-text-field variant="outlined" label="Slug"
                     v-model="game.slug"
                     v-input-trim
                     disabled
                     maxlength="50"
              />
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="multiple-inputs-wrap">
            <div class="form__input-box">
              <v-text-field variant="outlined" label="Name"
                v-model="meta.name"
                v-input-trim
              />
            </div>
            <div class="form__input-box">
              <Loader v-if="gameOriginalDetailsLoadInProgress"></Loader>
              <v-text-field v-else variant="outlined" label="Original Name"
                     v-model="game.name"
                     disabled
              />
            </div>
          </div>
        </div>

        <div class="form__row">
          <div class="multiple-inputs-wrap">
            <div class="form__input-box">
              <v-textarea label="Description"
                        v-model="meta.description">
              </v-textarea>
            </div>
            <div class="form__input-box">
              <Loader v-if="gameOriginalDetailsLoadInProgress"></Loader>
              <v-textarea v-else label="Original Description"
                        v-model="gameMeta.description"
                        readonly
                        disabled>
              </v-textarea>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="form__input-box">
            <label class="form__label">Original Rules</label>
            <PrismEditor class="prism-html-edit"
                         v-model="gameMeta.rules"
                         language="html"
                         :lineNumbers="true"
                         :readonly="true">
            </Prismeditor>
          </div>
        </div>
        <div class="form__row">
            <div class="form__input-box">
              <label class="form__label">Rules</label>
              <PrismEditor class="prism-html-edit"
                           v-model="meta.rules"
                           language="html"
                           :lineNumbers="true"
                           :readonly="false">
              </Prismeditor>
            </div>
        </div>
        <div class="form__row">
          <div class="multiple-inputs-wrap">
            <div class="form__input-box">
              <v-textarea label="Html Title"
                          v-model="meta.htmlTitle">
              </v-textarea>
            </div>
            <div class="form__input-box">
              <Loader v-if="gameOriginalDetailsLoadInProgress"></Loader>
              <v-textarea v-else label="Original Html Title"
                          v-model="gameMeta.htmlTitle"
                          readonly
                          disabled>
              </v-textarea>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="multiple-inputs-wrap">
            <div class="form__input-box">
              <v-textarea label="Html Description"
                          v-model="meta.htmlDescription">
              </v-textarea>
            </div>
            <div class="form__input-box">
              <Loader v-if="gameOriginalDetailsLoadInProgress"></Loader>
              <v-textarea v-else label="Original Html Description"
                          v-model="gameMeta.htmlDescription"
                          readonly
                          disabled>
              </v-textarea>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="form__input-box">
            <label class="form__label">Rule Preview</label>
            <p class="prism-html-preview" v-html="meta.rules"></p>
          </div>
        </div>
        <div class="form__row">
          <v-combobox
            label="Categories"
            v-model="meta.categories"
            :items="categories.filter(c => c.locale === meta.locale)"
            item-text="name"
            return-object
            chips
            multiple>
          </v-combobox>
        </div>
        <div class="form-row">
          <Thumbs :thumbs="meta.thumbs"></Thumbs>
        </div>
      </div>

      <div class="form__row">
        <div class="btns-row__right-btns">
          <v-btn v-if="$checkRoles(['Administrator'])" @click="buttonSaveOnClick()">
            <Loader v-if="isFeedSaveInProgress"></Loader>
            <span v-else color="primary">Save</span>
          </v-btn>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import config from '../../../config'
  import {locales} from '@/constants/locales'
  import Loader from '../../Loader/Loader.vue'
  import Thumbs from '../../Thumbs/Thumbs.vue';

  import PrismEditor from 'vue-prism-editor'
  export default {
    name: 'FeedGameDetails',
    components: {Loader, PrismEditor, Thumbs},
    props: ['feed', 'feedGame'],
    data () {
      return {
        categories: [],
        game: {},
        gameMeta: {},
        metas: [],
        meta: { locale: 'en', categories: [] },
        cmbSchemas: null,
        isMetaDataSchemasLoading: true,
        locales: locales,
        selectedLocaleValue: locales[0].value,
        gameVersions: [],
        active: 'active',
        originalName: '',
        originalDescription: '',
        htmlTitle: '',
        htmlDescription: '',
        availableCategories: [],
        customCategory: '',
        isFeedSaveInProgress: false,
        gameOriginalDetailsLoadInProgress: false,
      }
    },
    created: async function () {
      this.categories = await this.$gameApi.get(`/dictionary/categories`);
      await this.updateData();
    },
    watch: {
      feedGame: async function () {
        await this.updateData();
      },
    },
    methods: {
      updateData: async function () {
        if (this.feedGame) {
          this.game = await this.$gameApi.get(`/games/${this.feedGame.game.id}`);
          this.metas = await this.$gameApi.get(`/feeds/${this.feed.id}/games/${this.feedGame.game.id}/metas`);
          const metaId = this.metas.find(m => m.locale === this.selectedLocaleValue)?.id;
          if (metaId) {
            this.meta = await this.$gameApi.get(`/feeds/${this.feed.id}/games/${this.feedGame.game.id}/metas/${metaId}`);
            // Normalize \n to empty string for text fields when loading data
            const textFields = ['description', 'rules', 'htmlDescription', 'htmlTitle'];
            textFields.forEach(field => {
              if (this.meta[field] === '\n') {
                this.meta[field] = '';
              }
            });
          } else {
            this.meta = { locale: this.selectedLocaleValue, categories: [] };
          }
          this.gameMeta = this.game.gameMetas.find(f => f.locale === this.selectedLocaleValue);
        }
      },
      buttonSaveOnClick: async function () {
        const baseUrl = `/feeds/${this.feed.id}/games/${this.feedGame.game.id}/metas`;

        // Normalize \n to empty string for text fields
        const normalizeField = (value) => value === '\n' ? '' : (value || '');
        
        const model = {
          id: this.meta.id || 0,
          locale: this.selectedLocaleValue,
          name: this.meta.name || '',
          description: normalizeField(this.meta.description),
          rules: normalizeField(this.meta.rules),
          alias: this.meta.alias || '',
          htmlTitle: normalizeField(this.meta.htmlTitle),
          htmlDescription: normalizeField(this.meta.htmlDescription),
          categories: this.meta.categories || [],
        };

        if (this.meta.id) {
          await this.$gameApi.patch(`${baseUrl}/${this.meta.id}`, model);
        } else {
          await this.$gameApi.post(`${baseUrl}`, model);
        }

        this.$swal.fire({
          position: 'top-end',
          showConfirmButton: false,
          timer: 3500,
          icon: 'success',
          title: 'Game Meta Data has been saved!',
          text: ``
        });
      },
      localeSelectOnChange: function () {
        this.initMetaByGameAndLocale()
      },
      initMetaByGameAndLocale: function() {
        this.meta = this.metas.find(m => m.locale === this.selectedLocaleValue) || { locale: this.selectedLocaleValue, categories: [] };
      },
    }
  }
</script>

<style scoped src="./FeedGameDetails.scss" lang="scss"></style>
